import _ from "underscore";
import {CellItem} from './cellItem';
import {ValidateResult} from '../contentType';
import {Questionary} from '../questionary';
import {XmlTagInfo} from '../xmlTagProvider';
import {syntheticItemView} from "../../ui/items/synthetic";
import {Form} from "../form/form";
import Cell from "../form/cell";

export class SyntheticItem extends CellItem {

	private validateMessage?: string;
	private visible: boolean;

	static fromXml(config: XmlTagInfo){
		return new SyntheticItem(config);
	}
	constructor(config: XmlTagInfo) {
		super(config);
		this.visible = config.attributes['visible'] === 'yes';
	}

	init (questionary: Questionary, form: Form, cell: Cell){
		super.init(questionary, form, cell);
		// set validate message
		var validateMessageTags = this.childrenTags.filter(n => n.tag === 'validateMessage');
		this.validateMessage = validateMessageTags[0] ? validateMessageTags[0].value : undefined;
	}

	getView() {
		return syntheticItemView(this);
	}

	validate() {
		const value = this.getVariable();
		const valid = value !== 0 && value !== null && !_.isUndefined(value);
		return valid ? ValidateResult.okResult() : ValidateResult.errorResult(this.validateMessage);
	}

	empty() {
		return true;
	}

	isVisible(): boolean {
		return this.visible;
	}
}